import { type FC, type ReactNode } from 'react';

import {
  ErrorPage,
  type ErrorPageProps,
} from '#packages/web/layouts/page/templates';
import { Message } from '#packages/web/foundations/feedback/message';
import { ActionButton } from '#packages/web/foundations/buttons/action-button';

export type UnexpectedErrorPageProps = ErrorPageProps & {
  /**
   * The error that occurred.
   */
  error: Error;

  /**
   * Callback when the action button is clicked.
   */
  onActionClick: () => void;

  /**
   * Text for the action button.
   */
  actionButtonText?: ReactNode;
};

export const UnexpectedErrorPage: FC<UnexpectedErrorPageProps> = ({
  error,
  actionButtonText = 'Retry',
  onActionClick,

  ...props
}) => (
  <ErrorPage
    message={[
      <Message key={1}>Something went wrong!</Message>,
      <Message key={2}>{error.message}</Message>,
    ]}
    action={
      <ActionButton onClick={onActionClick}>{actionButtonText}</ActionButton>
    }
    {...props}
  />
);
